import qs from 'qs';
import { useQuery } from 'react-query';

import { getWBSs as queryFn } from 'api/endPoints/getWBSs';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetWbs = (params: Pick<QueryParams, 'latestVersion' | 'filter'>) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getWbs', params],
        queryFn: () =>
            queryFn({
                latestVersion: params.latestVersion as number,
                filter: params.filter,
            }),
        enabled: Boolean(params.latestVersion),
    });
};

export const useQueryGetSingleWbs = (params: Pick<QueryParams, 'latestVersion' | 'taskId'>) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getSingleWbs', params],
        queryFn: () =>
            queryFn({
                latestVersion: params.latestVersion as number,
                taskId: params.taskId,
            }),
        enabled: Boolean(params.latestVersion) && Boolean(params.taskId),
    });
};

export interface QueryParams {
    latestVersion?: number;
    filter?: string;
    taskId?: string | null;
}

export interface QueryResponse {
    activity_id: string;
    id: number;
    name: string;
    task_version_hash_code: string;
    wbs_level: number;
}
